<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
        persistent
     
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>

        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">                
            <template>
                <v-row>
                    <v-col cols="11">
                        <v-text-field 
                            ref="ruc"
                            v-model="companyForm.ruc" 
                            label="Ruc" 
                            outlined
                            :rules="[() => !!companyForm.ruc || 'Es necesario ingresar ruc']"
                            hide-details="auto"
                            ></v-text-field>
                    </v-col>
                    <v-col cols="1" class="pl-0">
                        <v-icon class="mt-2" @click="handleSearchDocument">fas fa-search</v-icon>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            ref="name" 
                            v-model="companyForm.name" 
                            label="Razón Social" 
                            outlined 
                            :rules="[() => !!companyForm.name || 'Es necesario ingresar razón social']"
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- <v-row>
                    <v-col cols="12">
                        <v-text-field
                            ref="commission"
                            v-model="companyForm.commission"
                            label="Comisión"
                            outlined
                            :rules="[() => !!companyForm.commission || 'Es necesario ingresar la comisión']"
                            hide-details="auto"
                            prefix="%"
                            type="number"
                            min=0
                            max=100
                            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                        ></v-text-field>
                    </v-col>
                </v-row> -->

                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="companyForm.trade_name" 
                            label="Nombre Comercial" 
                            outlined 
                            hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="companyForm.email" 
                            label="Correo electrónico" 
                            outlined 
                            hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="companyForm.phone" 
                            label="Teléfono" 
                            outlined 
                            hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            outlined
                            label="Dirección"
                            v-model="companyForm.address"
                            >
                        </v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                        v-model="companyForm.credit_amount"
                        label="Crédito"
                        outlined
                        hide-details
                        prefix="S/"
                        type="number"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </template>                    
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'" dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                        <v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: 'CreateUpdate',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            companyForm: {
                id: null,
                ruc: null,
                name: null,
                trade_name: null,
                email: null,
                address: null,
                phone: null,
                commission:null,
                credit_amount: null,
            }
        }
    },
    computed: {
        ...mapState("clients", [
            "clients",
            "client"
            ]),
    },
    methods: {
        ...mapActions('clients', [
            'store',
            'update',
            'searchDocument',
            'emptyCompany'
        ]),
        async showForm(title, action, client = null) {
            await this.clearData();
            this.titleForm = title            
            this.action = action
            if (client) {
                this.setCompany(client);
            }
            this.drawer = !this.drawer
        },
        closeForm() {
            this.clearData()
            this.drawer = false
        },
        clearData() {
            this.titleForm = null
            this.action = null
            this.companyForm.id = null
            this.companyForm.ruc = null
            this.companyForm.name = null
            this.companyForm.trade_name = null
            this.companyForm.email = null
            this.companyForm.address = null
            this.companyForm.phone = null
            this.companyForm.credit_amount = null
            this.clearErrors();
        },
        clearErrors() {
            Object.keys(this.companyForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
        async handleSearchDocument() {
            this.searching = true;
            if (this.companyForm.ruc) {
                let ruc = this.companyForm.ruc;
                await this.searchDocument(ruc);
                this.searching = false;
                if (this.client) {
                let personFounded = Object.assign({}, this.client);
                this.emptyCompany();
                this.companyForm.ruc = personFounded.document;
                this.companyForm.name = personFounded.name;
                this.companyForm.address = personFounded.address;
                //this.companyForm.surname = personFounded.surname;
                //this.companyForm.address = personFounded.address;
                }
            } else {
                this.searching = false;
            }
        },
        setCompany(client) {
            this.companyForm.id = client.id
            this.companyForm.ruc = client.ruc
            this.companyForm.name = client.name
            this.companyForm.trade_name = client.trade_name
            this.companyForm.email = client.email
            this.companyForm.address = client.address
            this.companyForm.phone = client.phone
            this.companyForm.commission = client.commission
            this.companyForm.credit_amount = client.credit_amount
        },
        async handleStore() {
            if (!this.existErrors()) {
                await this.store(this.companyForm);
                this.closeForm();
            }       
        },
        async handleUpdate() {
            if (!this.existErrors()) {
                await this.update(this.companyForm);
                this.closeForm();
            }            
        },
        handleCancel() {
            this.closeForm()
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.companyForm).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.companyForm[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        }
    }
}
</script>

<style scoped>

</style>